import './NightOverlay.css'

const NightOverlay = () => {
  return (
    <div className="night-overlay"></div>
  )
}

export default NightOverlay
